var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"coin-details"},[_c('CurrentCoinTableMobile'),_c('h4',{staticClass:"exchanges-title inner-container"},[_vm._v("Exchanges")]),_c('CoinExchangesTable')],1)}
var staticRenderFns = []

export { render, staticRenderFns }